export enum InAppPurchaseType {
  purchase = 'purchase',
  refund = 'refund',
  user_id_update = 'user_id_update',
  subscription_renewal = 'subscription_renewal',
  subscription_renewal_retry = 'subscription_renewal_retry',
  subscription_grace_period_expire = 'subscription_grace_period_expire',
  subscription_product_change = 'subscription_product_change',
  subscription_replace = 'subscription_replace',
  subscription_cancel = 'subscription_cancel',
  subscription_uncancel = 'subscription_uncancel',
  subscription_expire = 'subscription_expire',
}

export interface InAppPurchaseWebhookPurchaseData {
  productSku: string;
  userId: string;
}
export interface InAppPurchaseWebhookResponse {
  id: string;
  type: InAppPurchaseType;
  version: string;
  data: InAppPurchaseWebhookPurchaseData;
}
